import {
	ClientPortfolioToolIdentificationTypeEnum,
	ClientPortfolioToolTypeEnum,
} from "web_myplann/Infrastructure/Api/Api";
import { ToolKind } from "web_myplann/Portfolio/Helpers/investmentToolTypes";

export const EXCLUDED_IDENTIFICATION_TYPES = [
	ClientPortfolioToolIdentificationTypeEnum.Crypto,
	ClientPortfolioToolIdentificationTypeEnum.Null,
	ClientPortfolioToolIdentificationTypeEnum.BankProduct,
	ClientPortfolioToolIdentificationTypeEnum.None,
] as const;

export const isFundLikeToolType = (type: ClientPortfolioToolTypeEnum | null) =>
	type !== ClientPortfolioToolTypeEnum.Commodity &&
	type !== ClientPortfolioToolTypeEnum.Crypto &&
	type !== ClientPortfolioToolTypeEnum.BankProduct;

type ToolKindSource = {
	type: ClientPortfolioToolTypeEnum | null;
};

export const getInvestmentToolKind = ({ type }: ToolKindSource): ToolKind => {
	switch (type) {
		case ClientPortfolioToolTypeEnum.Bond:
			return ToolKind.Bond;
		case ClientPortfolioToolTypeEnum.Commodity:
			return ToolKind.Commodity;
		case ClientPortfolioToolTypeEnum.Crypto:
			return ToolKind.Crypto;
		case ClientPortfolioToolTypeEnum.BankProduct:
			return ToolKind.BankProduct;
		default:
			return ToolKind.Investment;
	}
};
